require('/opt/odin/app/frontend/pages/landing_xray/index/components/meet/index.scss');module.exports = "../../app/cells/pages/landing_xray/index/meet/show.erb";